import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { getCaseStyle, formatNull, formatDate } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';
import ViewFileById from '../ViewFileById';

import Modal from '../Modal';
import EditEmploymentHistory from './Components/EditEmploymentHistory';

import TKPanel from './Components/TKPanel';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

import IconContainer from '../IconContainer';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const WorkExperience = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-user-employment-history?id=${userId}`)
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      console.error(error);
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-emloyment-history', {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isEditModal, setIsEditModal] = React.useState(false);

  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsEditModal(true);
  };

  return (
    <>
      <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
          <EditEmploymentHistory id={currentId} action={currentAction} userId={userId} onSuccess={() => setReload(true)} />
      </Modal>

      <TKPanel userId={userId} />
      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
              <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                  <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                </svg>
                Добавить сведения о стаже
              </button>
              <a className='lastUpdateWrapper'>
                  {loading ? 
                      <Loading type='inline' /> 
                  : 
                      <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                  }
              </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '10fr 25fr 10fr 24fr 10fr 15fr 6fr' }}>
              <div>Тип</div>
              <div>Организация</div>
              <div>Дата приема</div>
              <div>Должность</div>
              <div>Дата ухода с должности</div>
              <div>Скан свидетельства и иных документов</div>
              <div></div>
          </div>
        </div>
        {loading ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem) => (
            <div 
              className='tableRow nonActive' 
              style={{ gridTemplateColumns: '10fr 25fr 10fr 24fr 10fr 15fr 6fr' }}
              key={caseItem.id} 
            >
              <div>{formatNull(caseItem.type)}</div>
              <div>{formatNull(caseItem.organization_name)}</div>
              <div>{formatDate(caseItem.admission_date)}</div>
              <div>{formatNull(caseItem.job_title)}</div>
              <div>{formatDate(caseItem.leaving_date)}</div>
              <div>
                <ViewFileById fileId={caseItem.file_id} />
              </div>
              <div style={{alignItems: 'end'}}>
                  <div className='horizontalCell'>
                    <IconContainer Icon={PenIcon} onClick={() => {openSuperModal(caseItem.id, 'change')}} size = '17' color = 'blue' className = '' />
                    <ButtonWithConfirmation 
                        entryFunc={() => {deleteEntry(caseItem.id)}} 
                        Icon={TrashIcon} 
                        IconSize={17}
                        buttonName='Удалить' 
                        color='red' 
                    />
                  </div>
              </div>
            </div>
        ))}
      </div>
    </>
  )
}

export default WorkExperience;